import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import React from 'react';
import { useSelector } from 'react-redux';

export function useWindowTitle() {
    const settings = useSelector(getSettings);
    React.useEffect(() => {
        window.document.title = settings.appTitle;
    }, [settings.appTitle]);
}
